module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-返回顶部.fa3a4.png";